import {useAtom, useAtomValue} from 'jotai';
import styled from 'styled-components';
import {useGA4WithParams} from '@/hooks/tracking';
import {
  mapAgentTypeAtom,
  mobileAnalysisActiveTabAtom,
  mobileBottomSheetFullTopAtom,
  mobileBottomSheetTopAtom,
} from '@/map/atom';
import AiIconSvg from '@/map/components/AiPrompt/assets/ai-icon.svg';
import {AnalysisTabType} from '@/map/enums';
import {LAYOUT_Z_INDEX, palette} from '@/styles';
import {SHEET_COLLAPSED_TOP} from '../BottomSheet';

// 시트가 접힘 위치 근처(+여유 80px)일 때만 버튼 노출. 드래그로 확장 중이면 숨김.
const COLLAPSED_SLACK = 80;

export const AiReportButton = () => {
  const [activeTab, setActiveTab] = useAtom(mobileAnalysisActiveTabAtom);
  const [topPosition, setTopPosition] = useAtom(mobileBottomSheetTopAtom);
  const fullTop = useAtomValue(mobileBottomSheetFullTopAtom);
  const mapAgent = useAtomValue(mapAgentTypeAtom);

  const tracking = useGA4WithParams();

  // 이미 AI 탭이거나, 시트가 확장된 상태(또는 미초기화)면 숨김
  const isCollapsed =
    topPosition > 0 && topPosition <= SHEET_COLLAPSED_TOP + COLLAPSED_SLACK;

  if (activeTab === AnalysisTabType.ai || !isCollapsed) {
    return null;
  }

  const onClick = () => {
    tracking('tab_select', {agent: mapAgent, tabName: 'AI 해설'});
    setActiveTab(AnalysisTabType.ai);
    // 시트 완전 확장 (측정된 full top이 없으면 화면 높이로 폴백)
    setTopPosition(fullTop || window.innerHeight);
  };

  return (
    <Root topPosition={topPosition} onClick={onClick}>
      <AiIcon />
      <Label>AI 상권 해설 보고서</Label>
    </Root>
  );
};

const Root = styled.button<{topPosition: number}>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: ${({topPosition}) => `${topPosition + 12}px`};
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  display: flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background-color: ${palette.white};
  border: 1px solid ${palette.gray200};
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  white-space: nowrap;
  transition: bottom 400ms;
`;

const AiIcon = styled.span`
  background-image: url(${AiIconSvg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Label = styled.span`
  color: ${palette.blue500};
  font-size: 13px;
  font-weight: 500;
`;
